import React, { useEffect, useState } from 'react'
import { APICall } from '../../../Helpers/API/APICalls'
import { getRatingStatusDropDown, getTeamMembersDropDown } from '../../../Helpers/API/APIEndPoints'

export const useCommonDropDown = () => {
    const[statusDropDown,setStatusDropDown]=useState([])
    const[teamMemberDropDown,setTeamMemberDropDown]= useState([])
     

    useEffect(()=>{
       (async()=>{
            await loadDropDownData();
       })();
    },[])


    const loadDropDownData=async()=>{
        
        const teamMemberData = await APICall(getTeamMembersDropDown,'POST',{})

       
        let tempTeamMembers = teamMemberData.data.map((teamMembers)=>({
            value:teamMembers.employeeId,
            label:teamMembers.employeeName,
        }))

    

        const statusData = await APICall(getRatingStatusDropDown,'POST',{})
        
      
        let tempStatus = statusData.data.map((ratingStatus)=>({
            value:ratingStatus.ratingStatusId,
            label:ratingStatus.ratingStatusLabel,
        }))

       
        await setTeamMemberDropDown(tempTeamMembers);
        await setStatusDropDown(tempStatus);
        

    }

    return{statusDropDown,teamMemberDropDown}
}

